(function () {
  'use strict';

  var overlay  = document.getElementById('cd-overlay');
  var drawer   = document.getElementById('cd-drawer');
  var closeBtn = document.getElementById('cd-close');
  var itemsEl  = document.getElementById('cd-items');
  var emptyEl  = document.getElementById('cd-empty');
  var footerEl = document.getElementById('cd-footer');
  var countEl  = document.getElementById('cd-count');
  var subtotalEl = document.getElementById('cd-subtotal');
  var checkoutBtn = document.getElementById('cd-checkout');
  var continueBtn = document.getElementById('cd-continue');

  if (!drawer) return;

  function formatMoney(cents, currencyCode) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currencyCode;
    }
  }

  function openDrawer() {
    overlay.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 300);
  }

  function updateHeaderCount(count) {
    var badge = document.querySelector('.jh-header__cart-count');
    var iconLinks = document.querySelectorAll('.jh-header__icon-link[aria-label="Cart"]');
    if (count > 0) {
      if (badge) {
        badge.textContent = count;
      } else {
        iconLinks.forEach(function (link) {
          var span = document.createElement('span');
          span.className = 'jh-header__cart-count';
          span.textContent = count;
          link.appendChild(span);
        });
      }
    } else if (badge) {
      badge.remove();
    }
  }

  function renderCart(cart) {
    countEl.textContent = cart.item_count;
    updateHeaderCount(cart.item_count);

    if (cart.item_count === 0) {
      itemsEl.hidden = true;
      footerEl.hidden = true;
      emptyEl.hidden = false;
      return;
    }

    itemsEl.hidden = false;
    footerEl.hidden = false;
    emptyEl.hidden = true;

    itemsEl.innerHTML = cart.items.map(function (item, index) {
      var variantText = item.variant_title ? item.variant_title.replace(/\s*\/\s*/g, ' / ') : '';
      return (
        '<div class="cd-item" data-line="' + (index + 1) + '">' +
          '<img class="cd-item__image" src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '') + '" alt="' + escapeHtml(item.product_title) + '">' +
          '<div>' +
            '<p class="cd-item__title">' + escapeHtml(item.product_title) + '</p>' +
            (variantText ? '<p class="cd-item__variant">' + escapeHtml(variantText) + '</p>' : '') +
            '<div class="cd-item__row">' +
              '<div class="cd-item__qty">' +
                '<button class="cd-item__qty-btn" data-action="decrease" type="button">&minus;</button>' +
                '<span class="cd-item__qty-value">' + item.quantity + '</span>' +
                '<button class="cd-item__qty-btn" data-action="increase" type="button">+</button>' +
              '</div>' +
              '<span class="cd-item__price">' + formatMoney(item.final_line_price, cart.currency) + '</span>' +
            '</div>' +
            '<button class="cd-item__remove" data-action="remove" type="button">Remove</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    subtotalEl.textContent = formatMoney(cart.total_price, cart.currency);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) {
          if (err.description) alert(err.description);
          return fetchCart();
        });
      }
      return r.json().then(function (cart) {
        renderCart(cart);
        return cart;
      });
    });
  }

  function addToCart(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantity || 1 }),
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (err) {
          throw new Error(err.description || 'Could not add item to cart');
        });
      }
      return fetchCart();
    });
  }

  // ── Wire up open/close ──────────────────────────────
  if (closeBtn)    closeBtn.addEventListener('click', closeDrawer);
  if (overlay)      overlay.addEventListener('click', closeDrawer);
  if (continueBtn)  continueBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  document.querySelectorAll('.jh-header__icon-link[aria-label="Cart"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart().then(openDrawer);
    });
  });

  // ── Line item quantity / remove ─────────────────────
  itemsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var row = btn.closest('.cd-item');
    var line = parseInt(row.dataset.line, 10);
    var qtyValue = row.querySelector('.cd-item__qty-value');
    var current = parseInt(qtyValue.textContent, 10);

    if (btn.dataset.action === 'increase') {
      changeLine(line, current + 1);
    } else if (btn.dataset.action === 'decrease') {
      changeLine(line, Math.max(0, current - 1));
    } else if (btn.dataset.action === 'remove') {
      changeLine(line, 0);
    }
  });

  // ── Checkout ─────────────────────────────────────────
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      window.location.href = '/checkout';
    });
  }

  // ── Intercept product add-to-cart form ──────────────
  var productForm = document.getElementById('jp-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = document.getElementById('jp-add-btn');
      var variantId = document.getElementById('jp-variant-id').value;
      if (addBtn) addBtn.disabled = true;

      addToCart(variantId, 1)
        .then(openDrawer)
        .catch(function (err) {
          alert(err.message);
        })
        .finally(function () {
          if (addBtn && !addBtn.classList.contains('is-soldout')) addBtn.disabled = false;
        });
    });
  }

  // ── Init header count on load ───────────────────────
  fetchCart();
})();
